export const ROUTE_ROOT = '/';
export const ROUTE_LOGIN = '/login';
export const ROUTE_MENTIONS_LEGALES = '/mentions-legales';

// ROUTEs B2C - B2B
export const ROUTE_B2B_B2C_SELECTOR = '/b2b-b2c-selector';
export const ROUTE_B2B_EA = '/pro/espace-agent';
export const ROUTE_B2C_EA = '/res/espace-agent';
